// extracted by mini-css-extract-plugin
export var dropdown = "_ns-1";
export var hidden = "_ns-0";